import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = ["element-loading-text"]
const _hoisted_2 = { class: "d-flex flex-column flex-md-row align-items-center col-12 my-8" }
const _hoisted_3 = {
  key: 0,
  class: "col-12 col-md-3 mx-2 d-flex"
}
const _hoisted_4 = { class: "form-check form-check-custom form-check-solid form-check-sm border border-dashed border-light border-hover-info bg-light-success py-2 px-2 rounded w-100" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label" }, " فقط اشتراک های فعال ", -1)
const _hoisted_6 = {
  key: 1,
  class: "col-12 col-md-3 mx-2 d-flex"
}
const _hoisted_7 = { class: "form-check form-check-custom form-check-solid form-check-sm border border-dashed border-light border-hover-info bg-light-success py-2 px-2 rounded w-100" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label" }, " استفاده از کدتخفیف ", -1)
const _hoisted_9 = {
  key: 2,
  class: "col-12 col-md-3 mx-2 d-flex"
}
const _hoisted_10 = { class: "form-check form-check-custom form-check-solid form-check-sm border border-dashed border-light border-hover-info bg-light-success py-2 px-2 rounded w-100" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label" }, " ربات های آنلاین ", -1)
const _hoisted_12 = { class: "mt-4 mt-md-0" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "mt-7 mx-3 text-primary fs-7" }
const _hoisted_15 = { class: "d-flex align-items-center flex-md-row flex-wrap" }
const _hoisted_16 = {
  key: 0,
  class: "d-flex col-12 col-md-2"
}
const _hoisted_17 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_18 = { class: "mb-1 fs-7" }
const _hoisted_19 = {
  class: "text-muted fw-bold d-block fs-7 text-end",
  dir: "ltr"
}
const _hoisted_20 = { class: "d-flex flex-column col-12 col-md-2" }
const _hoisted_21 = { class: "fs-7" }
const _hoisted_22 = { class: "fs-7 text-nowrap text-gray-600" }
const _hoisted_23 = { class: "d-flex flex-wrap align-items-center col-12 col-md-4" }
const _hoisted_24 = { class: "mt-3 mb-2 col-12 col-md-4 px-3" }
const _hoisted_25 = { class: "d-flex align-items-center fs-8 text-grey-700" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, " اشتراک : ", -1)
const _hoisted_27 = { class: "d-flex align-items-center" }
const _hoisted_28 = { class: "" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "fs-8 text-info" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", {
  class: "mx-1",
  style: {"border":"1px solid #7239ea","border-radius":"100px","display":"flex"}
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info fs-3 text-info" })
], -1)
const _hoisted_32 = { class: "d-flex align-items-center fs-8 text-grey-700" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", null, "تاریخ انقضا : ", -1)
const _hoisted_34 = {
  key: 0,
  class: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_UserAvatar = _resolveComponent("UserAvatar")!
  const _component_platform = _resolveComponent("platform")!
  const _component_NotConnectedPlatform = _resolveComponent("NotConnectedPlatform")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_Status = _resolveComponent("Status")!
  const _component_Date = _resolveComponent("Date")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    "element-loading-text": _ctx.translate('loading')
  }, [
    _createVNode(_component_el_tabs, {
      modelValue: _ctx.bots_type,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bots_type) = $event)),
      class: "demo-tabs",
      onTabClick: _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loading = true), _ctx.getItems(_ctx.bots_type)))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "اشتراک های خریداری شده",
          name: "buy"
        }),
        _createVNode(_component_el_tab_pane, {
          label: "اشتراک های رایگان",
          name: "free"
        }),
        _createVNode(_component_el_tab_pane, {
          label: "اشتراک های منقضی شده",
          name: "expired"
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.bots_type === 'buy' || _ctx.bots_type === 'free')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("label", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "form-check-input",
                value: "ready",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.status) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.status]
              ]),
              _hoisted_5
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.bots_type === 'buy' || _ctx.bots_type === 'expired')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "form-check-input",
                value: "1",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.buy_with_discount) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.buy_with_discount]
              ]),
              _hoisted_8
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.bots_type === 'buy' || _ctx.bots_type === 'free')
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("label", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "form-check-input",
                value: "1",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.only_online) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.only_online]
              ]),
              _hoisted_11
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          class: "btn btn-sm btn-primary",
          onClick: _cache[5] || (_cache[5] = ($event: any) => ((_ctx.loading = true), _ctx.getItems(_ctx.bots_type)))
        }, " اعمال "),
        _createElementVNode("a", {
          download: "",
          href: _ctx.excelLink,
          type: "button",
          class: "btn btn-sm btn-outline-success border-dashed mx-1",
          "data-kt-menu-dismiss": "true"
        }, " اکسل ", 8, _hoisted_13)
      ])
    ]),
    _createElementVNode("p", _hoisted_14, " تعداد کل ربات ها : " + _toDisplayString(_ctx.pagination?.total) + " ربات ", 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.botList, (item, index) => {
      return (_openBlock(), _createBlock(_component_el_card, {
        class: "my-4",
        style: _normalizeStyle([{"max-width":"100%","position":"relative"}, 
        item.pay_status === 'active'
          ? 'background : #edf5ff '
          : 'background : #ffebe8'
      ]),
        key: index
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_15, [
            (item.user)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(_component_UserAvatar, {
                    avatar: item.user.picture,
                    size: "40px",
                    id: item.user.id
                  }, null, 8, ["avatar", "id"]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, _toDisplayString(item.user.first_name) + " " + _toDisplayString(item.user.last_name), 1),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(item.user.mobile), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", null, [
                _createElementVNode("strong", _hoisted_21, _toDisplayString(item?.name), 1)
              ]),
              _createElementVNode("span", _hoisted_22, "(" + _toDisplayString(item.bot_id) + ") ", 1)
            ]),
            _createElementVNode("div", _hoisted_23, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.platforms, (plat, platIndex) => {
                return (_openBlock(), _createBlock(_component_platform, {
                  key: platIndex,
                  class: "ms-1",
                  "platform-info": plat,
                  platform: plat.platform,
                  avatar: plat.avatar,
                  logo: plat.platform_avatar,
                  number: plat.platform_number,
                  status: plat.status,
                  secretary: plat.enable_secretary,
                  botId: item.bot_id,
                  "package-support": 
              _ctx.checkPackagePlatform(item.package.platforms, plat.platform)
            ,
                  restrictedInfo: plat.restricted_info,
                  "show-btns": false,
                  online: "yes",
                  onUpdate: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getItems(_ctx.bots_type)))
                }, null, 8, ["platform-info", "platform", "avatar", "logo", "number", "status", "secretary", "botId", "package-support", "restrictedInfo"]))
              }), 128)),
              _createVNode(_component_NotConnectedPlatform, {
                platforms: 
              _ctx.checkNotActivePackagePlatform(
                item.package && item.package.platforms !== null
                  ? item.package.platforms
                  : [],
                item.platforms
              )
            ,
                botId: item.bot_id
              }, null, 8, ["platforms", "botId"])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("span", _hoisted_28, _toDisplayString(item.package?.package_name), 1)
                ]),
                (item.reserved_package)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                      _createVNode(_component_el_tooltip, {
                        placement: "top",
                        effect: "light"
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("span", _hoisted_30, " اشتراک " + _toDisplayString(item.reserved_package.package.name) + " رزرو شده، پس از اتمام اشتراک فعلی به صورت خودکار فعال خواهد شد. ", 1)
                        ]),
                        default: _withCtx(() => [
                          _hoisted_31
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  : _createCommentVNode("", true),
                (new Date(item.package?.expired_date.gregorian) < new Date())
                  ? (_openBlock(), _createBlock(_component_Status, {
                      key: 1,
                      status: "expired"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                (item.package && item.package.expired_date)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                      _createVNode(_component_Date, {
                        date: item.package.expired_date
                      }, null, 8, ["date"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _: 2
      }, 1032, ["style"]))
    }), 128)),
    (_ctx.pagination && _ctx.pagination.total_pages > 1)
      ? (_openBlock(), _createBlock(_component_el_pagination, {
          key: 0,
          pagerCount: 4,
          background: "",
          layout: "prev, pager, next",
          class: "mt-4 mb-4 text-center direction-rtl",
          total: _ctx.pagination.total,
          currentPage: _ctx.pagination.current_page,
          "page-size": _ctx.pagination.per_page,
          onSizeChange: _ctx.handleSizeChange,
          onCurrentChange: _ctx.handleCurrentChange
        }, null, 8, ["total", "currentPage", "page-size", "onSizeChange", "onCurrentChange"]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1)), [
    [_directive_loading, _ctx.loading]
  ])
}